export default "__VITE_ASSET__3lKDcmf4__"